export default {
  install(Vue) {
    Vue.filter('time', date => (date
      ? `${date.getHours() > 9 ? '' : '0'}${date.getHours()}:${date.getMinutes() > 9 ? '' : '0'}${date.getMinutes()}`
      : ''));
  },
};
